/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiMacroprojectsIdMutationResponse,
  DeleteApiMacroprojectsIdPathParams,
} from '../models/DeleteApiMacroprojectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiMacroprojectsIdMutationResponseSchema } from '../zod/deleteApiMacroprojectsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiMacroprojectsIdMutationKey = () =>
  [{ url: '/api/macroProjects/:id' }] as const;

export type DeleteApiMacroprojectsIdMutationKey = ReturnType<
  typeof deleteApiMacroprojectsIdMutationKey
>;

/**
 * {@link /api/macroProjects/:id}
 */
export async function deleteApiMacroprojectsId(
  id: DeleteApiMacroprojectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiMacroprojectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/macroProjects/${id}`,
    ...requestConfig,
  });
  return deleteApiMacroprojectsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/macroProjects/:id}
 */
export function useDeleteApiMacroprojectsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiMacroprojectsIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiMacroprojectsIdPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiMacroprojectsIdMutationKey();

  return useMutation<
    DeleteApiMacroprojectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiMacroprojectsIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiMacroprojectsId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
